import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { Constants } from 'src/app/core/constants';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import Helper from 'src/app/core/utility/helper';
import UIHelper from 'src/app/core/utility/ui-helper';
import { FormFileToBeUploaded } from 'src/app/models/internal/formfile-tobe-uploaded';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';

class FileUploadSnippet {
  pending: boolean = false;
  status: string = 'init';

  constructor(public src: string, public file: File) {}
}

@Component({
  selector: 'app-pe-bulkupload',
  templateUrl: './pe-bulkupload.component.html',
  styleUrls: ['./pe-bulkupload.component.scss']
})
export class PeBulkuploadComponent implements OnInit, ICanExportData {
  excelFilenamePrefix = "BulkUploadProposalsResults_";
  bulkUploadResponse: any;
  bulkUploadExcelForm = this.fb.group({
    file: [null, Validators.required],
  });
@Input() isUpdateMode: boolean;
fileStream = '';
errorList: String[] = null;
selectedFile: FileUploadSnippet;

constructor(
  private fb: FormBuilder,
  private toastService: ToastService,
  private cd: ChangeDetectorRef,
  private dataService: DataService,
  protected logger: NGXLogger
) { }

ngOnInit() {
}

onFileChanged(imageInput: any) {
  this.errorList = null;
  const file: File = imageInput.files[0];
  const reader = new FileReader();
  this.errorList = null;
  reader.addEventListener('load', (event: any) => {
    this.selectedFile = new FileUploadSnippet(event.target.result, file);
        this.fileStream = event.target.result;
        this.selectedFile.pending = true;
        const formFileToBeUploaded: FormFileToBeUploaded = {
            File: this.selectedFile.file,
        };
      this.dataService
        .uploadBulkCreateProposalsExcel(
          formFileToBeUploaded.File
        )
        .subscribe((response: any) => {
          if (response != null) {
                this.logger.debug('Excel upload response for bulk upload proposals= ' + response);
                this.bulkUploadResponse = response;
                if (!response.Success) {
                  this.logger.debug('Excel upload for bulk upload proposals failed');
                  // this.errorList = response.Messages;
                } else {
                  this.toastService.info(Constants.SUCCESS_FILE_UPLOAD + " Please check the donwloaded file for success/failure for each proposal set");
                }
                this.exportData();
            }
        });
      });
  reader.readAsDataURL(file);

}

exportData()
    {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        UIHelper.DownloadExcelFile(this.bulkUploadResponse.Data, filename);
    }
}
